module.exports = __webpack_public_path__ + "img/vps.8db68a4.svg";